import { render } from "./CardBackground.vue?vue&type=template&id=bbb24a24&scoped=true"
import script from "./CardBackground.vue?vue&type=script&lang=js"
export * from "./CardBackground.vue?vue&type=script&lang=js"

import "./CardBackground.vue?vue&type=style&index=0&id=bbb24a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb24a24"]])

export default __exports__